import { Component, Input, type OnInit } from '@angular/core';
import { SidenavService } from './sidenav.service';
import { Router } from '@angular/router';
import { ATHORA_PILLS_EXTERNAL_LINK, INTESA_PILLS_EXTERNAL_LINK, PILLS_EXTERNAL_LINK } from './sidenav.constants';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
})
export class SidenavComponent {

  showPillsDetail: boolean = false;
  chevronIcon: string = 'chevron_right';

  constructor(
    private readonly _sidenavService: SidenavService,
    private readonly _router: Router
  ) {}

  get opened(): boolean {
    return this._sidenavService.opened;
  }

  toggleSidenav() {
    this._sidenavService.toggle();
  }

  navigate(destination: string) {
    if (destination === '/pills') {
      this.showPillsDetail = !this.showPillsDetail;
    } else if (destination === '/athora-pills') {
      window.open(ATHORA_PILLS_EXTERNAL_LINK, '_blank', 'noopener,noreferrer');
    } else if (destination === '/intesa-pills') {
      window.open(INTESA_PILLS_EXTERNAL_LINK, '_blank', 'noopener,noreferrer');
    } else {
      this._router.navigate([destination]).finally(() => {
        this.toggleSidenav();
      });
    }
  }
}
